module.exports = __webpack_public_path__ + "static/media/Kalimati.227d1939.ttf";